import { render } from "./FooterBlock.vue?vue&type=template&id=1a797e1b&scoped=true"
import script from "./FooterBlock.vue?vue&type=script&lang=js"
export * from "./FooterBlock.vue?vue&type=script&lang=js"

import "./FooterBlock.vue?vue&type=style&index=0&id=1a797e1b&scoped=true&lang=css"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a797e1b"]])

export default __exports__